/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentsListAgents } from "../../funcs/agentsListAgents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAgentsRequest$inboundSchema,
};

export const tool$agentsListAgents: ToolDefinition<typeof args> = {
  name: "agents-list-agents",
  description: `List agents`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentsListAgents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
